module.exports = __webpack_public_path__ + "static/img/md.61fa735.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/md.jpg
// module id = 6BJM
// module chunks = 171